import { useMutation } from "@tanstack/react-query";
import { validateComoCredentials } from "../../api/bComoApi";

export const useValidateComo = () => {
  return useMutation({
    mutationKey: ["validate-como"],
    mutationFn: (data) => validateComoCredentials(data),
    onError: (error) => {
      console.error("Como validation error details:", error.response || error);
    },
  });
};
